<template>
    <div class="practice-create mb-3 mt-page">

        <data-form :title="$i18n.gt('HEADING_CREATE_PRACTICE')"
                   :save-button-label="$i18n.gt('LABEL_SAVE')"
                   :field-model="practiceFields"
                   :field-groups="fieldGroups"
                   :load-model-instance="loadModelInstance"
                   :on-submit-handler="onSubmit"
                   :submit-success-message="$i18n.gt('LABEL_PRACTICE_CREATED')"
                   :submit-error-message="$i18n.gt('LABEL_ERROR_CREATING_PRACTICE')"
                   :submit-success-route="successRoute"
                   :cancel-route="successRoute">
        </data-form>

    </div>
</template>

<script>

import Vue from 'vue'
import PracticeFields from '@/models/Practice'

/**
 * Page for admin to create a Practice
 */
export default Vue.extend({
    name: "PracticeCreate",
    props: {
        companyId: Number,
        resellerId: Number,
    },
    data() {
        return {
            practiceFields: PracticeFields,
            fieldGroups: [
                ["name", "npi", "practice_code_id"],
                ["address", "address2", "city", "state", "zip", "email", "website", "phone", "fax"],
                ["type", "comment", "use_dietid_questionnaire", "disabled"],
            ],
        }
    },
    computed: {
        successRoute() {
            if (this.$user.roleIsAdmin()) {
                return `/practice/admin/companyId/${this.companyId}`
            } else if (this.$user.roleIsResellerAdmin()) {
                return `/practice/resellerAdmin/${this.resellerId}/companyId/${this.companyId}`
            } else {
                return `/practice/companyAdmin/companyId/${this.companyId}`
            }
        }
    },
    methods: {
        loadModelInstance() {
            return new Promise((resolve, reject) => {
                const practice = {
                    company_id: this.companyId
                }
                resolve(practice)
            })
        },
        onSubmit(modelInstance) {
            return this.$api.createItem(this, 'practice', modelInstance)
        }
    }
})

</script>

